import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StudentService {

  constructor(
    private http: HttpClient
  ) { }

  // STUDENTS API
  getStudents(item): Observable<any> {
    return this.http.get(environment.apiUrl + `api/v1/admin/students?${item?.filter?.student_number ? `filter%5Bstudent_number%5D=${item?.filter?.student_number}&` : ''}${item?.filter?.name ? `filter%5Bname%5D=${item?.filter?.name}&` : ''}${item?.filter?.email ? `filter%5Bemail%5D=${item?.filter?.email}&` : ''}${item?.filter?.birth_date ? `filter%5Bbirth_date%5D=${item?.filter?.birth_date}&` : ''}${item?.filter?.guardian_name ? `filter%5Bguardian_name%5D=${item?.filter?.guardian_name}&` : ''}${item?.filter?.mobile_number ? `filter%5Bmobile_number%5D=${item?.filter?.mobile_number}&` : ''}${item?.filter?.has_latest_assessment ? `filter%5Bhas_latest_assessment%5D=${item?.filter?.has_latest_assessment}&` : ''}${item?.filter?.has_latest_enrollment ? `filter%5Bhas_latest_enrollment%5D=${item?.filter?.has_latest_enrollment}&` : ''}${item?.filter?.has_latest_preenlistment ? `filter%5Bhas_latest_preenlistment%5D=${item?.filter?.has_latest_preenlistment}&` : ''}include=${item?.include?.latestAssessment ? 'latestAssessment,' : ''}${item?.include?.latestEnrollmentStatus ? 'latestEnrollmentStatus,' : ''}${item?.include?.latestPreEnlistmentStatus ? 'latestPreEnlistmentStatus,' : ''}`
      , { withCredentials: true });
  }

  getStudentsByUrl(url): Observable<any> {
    return this.http.get(url, { withCredentials: true });
  }

  createStudent(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/students', JSON.stringify(item), {withCredentials: true});
  }

  updateStudent(item: any, studentId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/students/${studentId}`, JSON.stringify(item), {withCredentials: true});
  }

  // STUDENTS FEES API
  getStudentFees(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/student-fees', {withCredentials: true});
  }

  createStudentFees(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/student-fees', JSON.stringify(item), {withCredentials: true});
  }

  updateStudentFees(item: any, studentFeeId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/student-fees/${studentFeeId}`, JSON.stringify(item), {withCredentials: true});
  }

  // STUDENTS PRE-ENLISTMENTS API
  getStudentPreEnlistments(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/student-preenlistments', {withCredentials: true});
  }

  createStudentPreEnlistment(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/student-preenlistments', JSON.stringify(item), {withCredentials: true});
  }

  updateStudentPreEnlistment(item: any, preEnlistmentId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/student-preenlistments/${preEnlistmentId}`, JSON.stringify(item), {withCredentials: true});
  }

  // GRADE CONVERSION API
  getGradeConversions(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/grade-conversions', {withCredentials: true});
  }

  createGradeConversion(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/grade-conversions', JSON.stringify(item), {withCredentials: true});
  }

  updateGradeConversion(item: any, gradeConversionId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/grade-conversions/${gradeConversionId}`, JSON.stringify(item), {withCredentials: true});
  }

  // SUBJECT API
  getSubjects(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/subjects', {withCredentials: true});
  }

  createSubject(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/subjects', JSON.stringify(item), {withCredentials: true});
  }

  updateSubject(item: any, subjectId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/subjects/${subjectId}`, JSON.stringify(item), {withCredentials: true});
  }

  // APPLICATION API
  getStudentApplications(schoolYear_id): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/admin/student-application/${schoolYear_id}/list`, {withCredentials: true});
  }

  updateApplicationStatus(applicationId: any, item: any): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/student-application/${applicationId}/update-status`, JSON.stringify(item), {withCredentials: true});
  }

  // PRE ENLISTMENT API
  getPreEnlistmentList(schoolYear_id): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/admin/pre-enlistment/${schoolYear_id}/list`, {withCredentials: true});
  }

  updatePreEnlistmentStatus(studentPreenlistment_id: any, item: any): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/pre-enlistment/${studentPreenlistment_id}/update-status`, JSON.stringify(item), {withCredentials: true});
  }

   // ASSESSMENT API
   getStudentAssessment(assessmentId): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/admin/assessment/${assessmentId}/details`, {withCredentials: true});
  }

  generateStudentAssessment(student_id: any, item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/admin/assessment/generate/${student_id}`, JSON.stringify(item), {withCredentials: true});
  }

  getStudentLatestAssessment(assessmentId): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/student/${assessmentId}/assessment`, {withCredentials: true});
  }

  getStudentSchedule(student_id: any, schoolYearTerm_id: any): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/student/${student_id}/schedules/${schoolYearTerm_id}`, {withCredentials: true});
  }
}